import React from "react";
import { FormControl, InputLabel, Select, MenuItem, Box, Typography, useTheme } from "@mui/material";
import { formatDate } from "../../../../utils/dateUtils";

const ReviewDropdown = ({ reviews, selectedReviewId, onReviewChange, vendorName }) => {
  const theme = useTheme();

  if (!reviews?.length) return null;

  return (
    <FormControl sx={{ minWidth: 320, mb: 0 }} size="small">
      <InputLabel id="security-review-select-label">Select Assessment</InputLabel>
      <Select
        labelId="security-review-select-label"
        value={selectedReviewId || ""}
        label="Select Assessment"
        onChange={(e) => onReviewChange(e.target.value)}
      >
        {reviews.map((review) => (
          <MenuItem key={review.id} value={review.id}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                width: "100%",
              }}
            >
              <Typography
                variant="body2"
                sx={{ color: theme.customColors?.text?.strong || "#111827" }}
              >
                {vendorName} - {review.title} - {formatDate(review.createdAt)}
              </Typography>
              <Typography
                variant="body2"
                sx={{ color: theme.customColors?.text?.secondary || "#6B7280" }}
              >
                {review.status}
              </Typography>
            </Box>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default ReviewDropdown;
